import React from 'react';
import { Link } from 'react-router-dom';
import { ARWMButton } from '../components/ARWMButton';
import { Card, CardHeader, CardTitle, CardContent } from '../components/Card';
import { Calendar, MapPin } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
export function Evenements() {
  useSEO('Événements - ARWM | Agenda Gastronomique Marrakech', "Découvrez les prochains événements de l'ARWM : formations, rencontres professionnelles, galas et conférences sur la restauration à Marrakech.");
  const events = [{
    id: 'rencontre-wali-2025',
    date: '15 Janvier 2025',
    title: 'Rencontre avec le Wali de Marrakech',
    location: 'Wilaya de Marrakech',
    description: 'Rencontre stratégique avec le Wali pour discuter des enjeux du secteur de la restauration et du développement touristique de la région.',
    image: 'https://images.unsplash.com/photo-1597212618440-806262de4f6b?w=800'
  }, {
    id: 'reunion-tourisme-2025',
    date: '22 Janvier 2025',
    title: 'Réunion sur le Tourisme Gastronomique',
    location: 'Siège ARWM',
    description: 'Session de travail dédiée au développement du tourisme gastronomique à Marrakech avec les acteurs clés du secteur.',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800'
  }, {
    id: 'formation-hygiene-2025',
    date: '5 Février 2025',
    title: 'Formation Hygiène et Sécurité Alimentaire',
    location: 'Centre de Formation',
    description: "Formation obligatoire sur les normes d'hygiène et de sécurité alimentaire pour tous les établissements membres.",
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800'
  }, {
    id: 'gala-gastronomie-2025',
    date: '20 Mars 2025',
    title: 'Gala de la Gastronomie Marocaine',
    location: 'Palais des Congrès',
    description: "Événement annuel célébrant l'excellence gastronomique marocaine avec remise de prix et dîner de gala.",
    image: 'https://images.unsplash.com/photo-1555244162-803834f70033?w=800'
  }, {
    id: 'salon-fournisseurs-2025',
    date: '15 Avril 2025',
    title: 'Salon des Fournisseurs',
    location: 'Parc des Expositions',
    description: 'Rencontre avec les meilleurs fournisseurs locaux et internationaux du secteur de la restauration.',
    image: 'https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?w=800'
  }, {
    id: 'conference-innovation-2025',
    date: '10 Mai 2025',
    title: 'Conférence Innovation & Restauration',
    location: 'Hôtel Sofitel',
    description: 'Conférence sur les nouvelles tendances et innovations dans le secteur de la restauration.',
    image: 'https://images.unsplash.com/photo-1508433957232-3107f5fd5995?w=800'
  }];
  return <div className="w-full" data-id="element-341">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-light-gray" data-id="element-342">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-343">
          <h1 className="font-cormorant text-7xl font-bold text-arwm-maroon mb-6" data-id="element-344">
            Événements ARWM
          </h1>
          <p className="font-josefin text-xl text-arwm-dark-text max-w-3xl mx-auto" data-id="element-345">
            Découvrez nos prochains événements et participez à la vie de
            l'association
          </p>
        </div>
      </section>

      {/* Events List */}
      <section className="py-20 px-4 bg-white" data-id="element-346">
        <div className="max-w-[1280px] mx-auto" data-id="element-347">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-348">
            {events.map(event => <Card key={event.id} data-id="element-349">
                <div className="h-48 bg-cover bg-center" style={{
              backgroundImage: `url(${event.image})`
            }} data-id="element-350" />
                <CardHeader data-id="element-351">
                  <div className="flex items-center text-arwm-maroon mb-2" data-id="element-352">
                    <Calendar className="w-4 h-4 mr-2" data-id="element-353" />
                    <span className="font-josefin text-sm" data-id="element-354">{event.date}</span>
                  </div>
                  <CardTitle className="font-cormorant text-2xl" data-id="element-355">
                    {event.title}
                  </CardTitle>
                </CardHeader>
                <CardContent data-id="element-356">
                  <div className="flex items-start text-arwm-dark-text mb-4" data-id="element-357">
                    <MapPin className="w-4 h-4 mr-2 mt-1 flex-shrink-0" data-id="element-358" />
                    <span className="font-josefin text-sm" data-id="element-359">
                      {event.location}
                    </span>
                  </div>
                  <p className="font-josefin text-arwm-dark-text mb-4" data-id="element-360">
                    {event.description}
                  </p>
                  <Link to={`/event-post/${event.id}`} data-id="element-361">
                    <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-362">
                      En savoir plus →
                    </span>
                  </Link>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-arwm-maroon" data-id="element-363">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-364">
          <p className="font-josefin text-sm uppercase tracking-[4px] text-arwm-cream mb-4" data-id="element-365">
            Ne manquez rien
          </p>
          <h2 className="font-cormorant text-5xl font-bold text-white mb-6" data-id="element-366">
            Ne Manquez Aucun Événement
          </h2>
          <p className="font-josefin text-xl text-arwm-cream mb-10 max-w-2xl mx-auto" data-id="element-367">
            Inscrivez-vous à notre newsletter pour recevoir toutes les
            informations sur nos événements
          </p>
          <Link to="/contact" data-id="element-368">
            <ARWMButton data-id="element-369">Nous Contacter</ARWMButton>
          </Link>
        </div>
      </section>
    </div>;
}